import { reduxForm, getFormSubmitErrors } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'lodash/fp/compose';
import _get from 'lodash/get';
import selectRegisteredFields from '../redux/suggest/selectors';
import { FORM_NAME } from '../consts';
import CarsSearchFrom from './CarsSearchForm';

const mapStateToProps = (state, ownProps) => {
  const { initialValues = {} } = ownProps;
  const { cars = {}, common = {} } = state;
  const { search = {}, suggest = {} } = cars;
  const { whitelabel = {} } = common;

  const { pickUp, dropOff } = initialValues;
  const validInitialValues = {
    ...initialValues,
    pickUp: _get(pickUp, 'name', ''),
    dropOff: _get(dropOff, 'name', ''),
  };

  const fieldNames = selectRegisteredFields(state);
  const errors = getFormSubmitErrors(FORM_NAME)(state);

  return {
    fieldNames: Object.keys(fieldNames),
    suggest,
    search,
    initialPickUpPoint: pickUp,
    initialDropOffPoint: dropOff,
    whitelabel,
    initialValues: validInitialValues,
    errors,
  };
};

export default compose(
  connect(mapStateToProps),
  reduxForm({
    form: FORM_NAME,
  })
)(CarsSearchFrom);
